<template>
  <div v-bind="$attrs" role="group">
    <slot></slot>
  </div>
</template>
